import { Text, View } from '@react-pdf/renderer';

import { Fragment } from 'react';

import { COMMENTARY_TEXT } from '../../commentary/consts.ts';
import { CommentarySection } from '../components/CommentarySection.tsx';
import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { fontStyles, priorSalesPageStyles } from '../styles.ts';
import { PriorSalesPageProps } from '../types.ts';

export const PriorSalesPage = ({
  subjectAddress,
  commentaryV2,
  compSequence,
  priorSales,
}: PriorSalesPageProps) => {
  const { title } = COMMENTARY_TEXT['prior-sales'];

  return (
    <Tkv2PDFPage title={title} address={subjectAddress}>
      <CommentarySection
        title="Prior Sales Commentary"
        commentary={commentaryV2.priorSales?.commentary}
      />

      {['subject', ...compSequence].map((id, i) => {
        const propertyPriorSales = priorSales[id];
        const propertyTitle = id === 'subject' ? 'Subject' : `Comparable ${i}`;

        if (!propertyPriorSales || propertyPriorSales.length === 0) {
          return (
            <Text key={id} style={fontStyles.body}>
              <Text style={fontStyles.bodyBold}>{propertyTitle} -&nbsp;</Text>
              No Prior Sales
            </Text>
          );
        }

        return (
          <Fragment key={id}>
            <Text style={fontStyles.bodyBold}>{propertyTitle}</Text>
            <View style={priorSalesPageStyles.table}>
              <View style={priorSalesPageStyles.tableColumn}>
                <View style={priorSalesPageStyles.tableCell}>
                  <Text style={fontStyles.body}>Prior Sale Date</Text>
                </View>
                <View style={priorSalesPageStyles.tableCell}>
                  <Text style={fontStyles.body}>Prior Sale Price</Text>
                </View>
                <View style={priorSalesPageStyles.tableCell}>
                  <Text style={fontStyles.body}>Prior Listing Date</Text>
                </View>
                <View style={priorSalesPageStyles.tableCell}>
                  <Text style={fontStyles.body}>Prior Listing Price</Text>
                </View>
                <View style={priorSalesPageStyles.tableCell}>
                  <Text style={fontStyles.body}>Data Source(s)</Text>
                </View>
              </View>
              {propertyPriorSales.map(
                ({ CloseDate, ClosePrice, ListingContractDate, ListPrice }) => (
                  <View key={CloseDate} style={priorSalesPageStyles.tableColumn}>
                    <View style={priorSalesPageStyles.tableCell}>
                      <Text style={fontStyles.body}>{CloseDate}</Text>
                    </View>
                    <View style={priorSalesPageStyles.tableCell}>
                      <Text style={fontStyles.body}>{ClosePrice}</Text>
                    </View>
                    <View style={priorSalesPageStyles.tableCell}>
                      <Text style={fontStyles.body}>{ListingContractDate}</Text>
                    </View>
                    <View style={priorSalesPageStyles.tableCell}>
                      <Text style={fontStyles.body}>{ListPrice}</Text>
                    </View>
                    <View style={priorSalesPageStyles.tableCell}>
                      <Text style={fontStyles.body}>MLS</Text>
                    </View>
                  </View>
                ),
              )}
            </View>
          </Fragment>
        );
      })}
    </Tkv2PDFPage>
  );
};
